import type { ResolvedZikr } from '@sayfazkari/content';
import { ru } from '../../strings/ru';
import styles from './ZikrCard.module.css';

interface Props {
  zikr: ResolvedZikr;
  showTranslit: boolean;
  showTranslation: boolean;
}

export function ZikrCard({ zikr, showTranslit, showTranslation }: Props) {
  return (
    <article className={styles.card}>
      <p className={styles.arabic} lang="ar" dir="rtl">
        {zikr.arabic}
      </p>

      {showTranslit && <p className={styles.translit}>{zikr.translit}</p>}

      {showTranslation && (
        <p className={styles.translation}>{zikr.translationRu}</p>
      )}

      <footer className={styles.meta}>
        <p className={styles.source}>
          <span className={styles.metaLabel}>{ru.session.source}: </span>
          {zikr.source.refRu}
          {zikr.source.grade && zikr.source.grade !== 'quran' && (
            <span className={styles.grade}> · {gradeRu(zikr.source.grade)}</span>
          )}
        </p>

        {zikr.fadlRu && (
          <p className={styles.fadl}>
            <span className={styles.metaLabel}>{ru.session.fadl}: </span>
            {zikr.fadlRu}
          </p>
        )}
      </footer>
    </article>
  );
}

function gradeRu(grade: string): string {
  switch (grade) {
    case 'sahih':
      return 'достоверный';
    case 'hasan':
      return 'хороший';
    case 'daif':
      return 'слабый';
    default:
      return grade;
  }
}
